import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const FollowUs = () => {
  const { t } = useTranslation();
  return (
    <article className="py-20 bg-white">
      <div className="w-11/12 mx-auto text-center">
        <h1 className="text-[20px] md:text-[32px] font-semibold text-mainBlue mb-10">
          {t("needMoreDetails")}
        </h1>
        <section className="flex flex-wrap items-center justify-center gap-2">
          <Link
            className="flex items-center justify-center gap-2 px-5 py-4 text-xl font-bold text-white rounded-lg hover:bg-mainBlue/90 bg-mainBlue"
            to="/contact-us"
          >
            {t("bookACall")}
          </Link>
          <Link
            className="flex items-center justify-center gap-2 px-5 py-4 text-xl font-bold text-white rounded-lg hover:bg-mainRed/80 bg-mainRed"
            to="/sign-in"
          >
            {t("signIn")}
          </Link>
        </section>
      </div>
    </article>
  );
};

export default FollowUs;
